import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { CerrixCalendarModule } from "@app/calendar/calendar.module";
import { SharedModule } from "./../shared/shared.module";
import { NavbarBugReportComponent } from "./navbar-plugins/navbar-bug-report/navbar-bug-report.component";
import { NavbarCalendarComponent } from "./navbar-plugins/navbar-calendar/navbar-calendar.component";
import { NavbarHelpComponent } from "./navbar-plugins/navbar-help/navbar-help.component";
import { NavbarI18nFeedbackComponent } from "./navbar-plugins/navbar-i18n-feedback/navbar-i18n-feedback.component";
import { NavbarSnowComponent } from "./navbar-snow/navbar-snow.component";
import { NavbarUserComponent } from "./navbar-plugins/navbar-user/navbar-user.component";
import { NavbarComponent } from "./navbar.component";
import { NavbarLightropeComponent } from "./navbar-lightrope/navbar-lightrope.component";

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        CerrixCalendarModule,
        NavbarBugReportComponent,
        NavbarI18nFeedbackComponent,
        NavbarHelpComponent,
        NavbarLightropeComponent,
        NavbarSnowComponent,
        NavbarUserComponent,
        NavbarCalendarComponent,
        NavbarComponent,
    ],
    exports: [NavbarComponent],
})
export class NavbarModule {
    static forRoot(): ModuleWithProviders<NavbarModule> {
        return {
            ngModule: NavbarModule,
            providers: [],
        };
    }
}
